import { REACT_APP_API, REACT_APP_ID } from "config";

// const token =
//   "VmX1AH6NucTzItKKP69fuxAXS4DLzUwnQKxkIjvhx104llh0CzIpxgNoGAkqTK4K";

export default class Fetcher {
  get(request) {
    return fetch(`${REACT_APP_API}${request.url}`, {
      credentials: "include",
      headers: {
        "content-type": "application/json",
        "accept-encoding": "gzip, deflate",
        "app-id": REACT_APP_ID,
        // "auth-server-token": token,
      },
      method: "GET",
    });
  }

  post(request) {
    return fetch(`${REACT_APP_API}${request.url}`, {
      body: JSON.stringify(request.body),
      credentials: "include",
      headers: {
        "content-type": "application/json",
        "app-id": REACT_APP_ID,
        // "auth-server-token": token,
      },
      method: "POST",
    });
  }

  data(request) {
    return fetch(`${REACT_APP_API}${request.url}`, {
      body: request.body,
      credentials: "include",
      headers: {
        "app-id": REACT_APP_ID,
        // "auth-server-token": token,
      },
      method: "POST",
    });
  }

  delete(request) {
    return fetch(`${REACT_APP_API}${request.url}`, {
      body: JSON.stringify(request.body),
      credentials: "include",
      headers: {
        "content-type": "application/json",
        "app-id": REACT_APP_ID,
        // "auth-server-token": token,
      },
      method: "DELETE",
    });
  }

  put(request) {
    return fetch(`${REACT_APP_API}${request.url}`, {
      body: JSON.stringify(request.body),
      credentials: "include",
      headers: {
        "content-type": "application/json",
        "app-id": REACT_APP_ID,
        // "auth-server-token": token,
      },
      method: "PUT",
    });
  }
}
